import {
  CommonRenderCellProps,
  CommonTableTemplate,
} from 'app/common/templates-next/table-template'

import { Td } from 'app/common/ui-components/table'
import { CellContentCheckSimple } from 'app/common/templates-next/table-template'
import PlainLink from 'app/common/ui-next/plain-link'
import { toFixedValueInt } from 'app/common/lib/toFixedValue'

import { WarehouseStockTableColumn, WarehouseStockTableDataItem } from './tableProps'
import { StockEditModal } from './StockEditModal'
import { StockEditModalOpen } from './StockEditModal/StockEditModalOpen'
import styles from './warehouseStockRenderCell.module.scss'

export const warehouseStockRenderCell = (
  params: CommonRenderCellProps<WarehouseStockTableDataItem, WarehouseStockTableColumn>,
) => {
  const { columnKey, cellProps, rowData } = params

  if (columnKey === WarehouseStockTableColumn.Check) {
    const title = rowData[columnKey]
    return (
      <Td {...cellProps}>
        <CellContentCheckSimple hiddenLabel={title} id={rowData.id} />
      </Td>
    )
  }

  if (columnKey === WarehouseStockTableColumn.Title) {
    const title = rowData[columnKey]
    return (
      <Td {...cellProps}>
        <label htmlFor={rowData.id}>{title}</label>
      </Td>
    )
  }

  if (columnKey === WarehouseStockTableColumn.Stock) {
    const { quantity, onSuccess } = rowData[columnKey]
    return (
      <Td {...cellProps}>
        <div className={styles.stock}>
          {toFixedValueInt(quantity)}
          <StockEditModalOpen>
            {(onClose) => (
              <StockEditModal
                id={rowData.id}
                title={rowData.title}
                stockQuantity={quantity}
                onClose={onClose}
                onSuccess={onSuccess}
              />
            )}
          </StockEditModalOpen>
        </div>
      </Td>
    )
  }

  if (columnKey === WarehouseStockTableColumn.Actions) {
    const { createDishMovementLink } = rowData[columnKey]
    return (
      <Td {...cellProps}>
        {createDishMovementLink && (
          <PlainLink to={createDishMovementLink(rowData.id)}>{'Движение продукции'}</PlainLink>
        )}
      </Td>
    )
  }

  return CommonTableTemplate.defaultRenderCell(params)
}
